import { render, staticRenderFns } from "./PeriodicTable.vue?vue&type=template&id=0f31a28e&scoped=true"
import script from "./PeriodicTable.vue?vue&type=script&lang=js"
export * from "./PeriodicTable.vue?vue&type=script&lang=js"
import style0 from "./PeriodicTable.vue?vue&type=style&index=0&id=0f31a28e&prod&lang=css&scoped=true"
import style1 from "./PeriodicTable.vue?vue&type=style&index=1&id=0f31a28e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f31a28e",
  null
  
)

export default component.exports